import { render, staticRenderFns } from "./ContaConfiguracaoExchangeAPI.vue?vue&type=template&id=39b9d3ac&scoped=true&"
import script from "./ContaConfiguracaoExchangeAPI.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracaoExchangeAPI.vue?vue&type=script&lang=js&"
import style0 from "./ContaConfiguracaoExchangeAPI.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContaConfiguracaoExchangeAPI.vue?vue&type=style&index=1&id=39b9d3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9d3ac",
  null
  
)

export default component.exports